/**
 * Paths into the Management tool.
 *
 * Portal has no react-router, so navigation is a full page load and these mirror
 * the `namespace :management` routes in config/routes.rb by hand. They live in one
 * place so the list's row links and the Edit User form cannot disagree about them.
 */
export const USERS_PATH = '/management/users';

export const userPath = (id) => `${USERS_PATH}/${id}`;

export const editUserPath = (id) => `${userPath(id)}/edit`;
